import React from "react";
import T from "prop-types";
import { Field } from "redux-form";
import { get } from "lodash";
import {
  FormRow,
  CheckGroup,
  Check,
  FormInput,
  CurrencyField
} from "MODULES/shared/components/Forms";
import { dollars } from "LIB/formatters/currency";
import Warning from "MODULES/shared/components/Warning/Warning";
import { Col } from "react-bootstrap";

export function Shipping({
  cancelled,
  exchanged,
  shipped,
  paid,
  commissionPaid,
  hazmat,
  biohazmat,
  canEditPartDetails,
  canEditOutgoingAwb,
  part
}) {
  const specialContainerFeeRequired = get(part, "special_container_req");
  const disabled =
    cancelled || exchanged || shipped || paid || !canEditPartDetails;

  return (
    <div>
      <h5 className="h4">Shipping</h5>
      <FormRow>
        <Col md={4}>
          <Field
            name="outgoing_awb_number"
            component={FormInput}
            label="Outgoing AWB #"
            disabled={!canEditOutgoingAwb}
          />
        </Col>
        <Col md={5}>
          <CheckGroup title="Heavy Package / DIM Weight" justified>
            <Field
              name="dim_weight"
              component={Check}
              label="Heavy Package / DIM Weight"
              disabled={!canEditPartDetails}
            />
          </CheckGroup>
        </Col>
        <Col md={3}>
          <CurrencyField
            name="hazmat_fee"
            label="Hazmat Fee"
            disabled={disabled || commissionPaid}
            required={hazmat || biohazmat}
          />
        </Col>
      </FormRow>
      {specialContainerFeeRequired && (
        <FormRow>
          <Col md={12}>
            <Warning warningType="warning">
              PN-{part.part_number} is flagged as requiring a special container
              fee of {dollars(part.special_container_fee)} and has been
              auto-populated below.
            </Warning>
          </Col>
        </FormRow>
      )}
      <FormRow>
        <Col md={3}>
          <CurrencyField
            name="container_fee"
            label="Container Fee"
            required={specialContainerFeeRequired}
            disabled={disabled || commissionPaid}
          />
        </Col>
        <Col md={3}>
          <Field
            name="core_return_awb_number"
            component={FormInput}
            label="Core Return AWB #"
          />
        </Col>
        <Col md={5}>
          <CheckGroup title="Customer To Return Container" justified>
            <Field
              name="customer_to_return_container"
              component={Check}
              label="Customer to Return Container"
            />
          </CheckGroup>
        </Col>
      </FormRow>
    </div>
  );
}

Shipping.propTypes = {
  cancelled: T.bool,
  exchanged: T.bool,
  paid: T.bool,
  shipped: T.bool,
  commissionPaid: T.bool,
  hazmat: T.bool,
  biohazmat: T.bool,
  canEditPartDetails: T.bool,
  canEditOutgoingAwb: T.bool,
  part: T.shape({
    id: T.number.isRequired
  })
};

export default Shipping;



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/Form/Shipping.jsx